import { render } from "./clima.vue?vue&type=template&id=c1e24eaa"
import script from "./clima.vue?vue&type=script&lang=js"
export * from "./clima.vue?vue&type=script&lang=js"

import "./clima.vue?vue&type=style&index=0&id=c1e24eaa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__